export default __webpack_public_path__ + "static/media/corporate6.115488c8.png";